import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DeviceSettingsService } from '../../library/device-settings.service';
import { ControlService } from '../../library/control.service';
import { CallStoreService } from '../../library/call-store/call-store.service';
import { TRANSLOCO_SCOPE } from '@jsverse/transloco';

@Component({
  selector: 'app-device-settings-modal',
  templateUrl: './device-settings-modal.component.html',
  styleUrls: ['./device-settings-modal.component.scss'],
  standalone: false,
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: 'settings',
    },
  ],
})
export class DeviceSettingsModalComponent implements OnInit, OnDestroy {
  @Input() deviceSettingsService: DeviceSettingsService | undefined;
  @Input() controlService: ControlService | undefined;

  constructor(private callStore: CallStoreService) {}

  // displayDeviceSettingsModal() only pauses the call for realtime/legacy-clip flows —
  // it explicitly skips pausing when callStore.isAudioCallMode() is true (pathway
  // PDF/Video narrator steps), so this modal has no other mechanism gating mic audio
  // in that mode. Registering unconditionally is redundant-but-harmless where pauseCall()
  // already blocks audio, and closes the real gap where it doesn't.
  ngOnInit(): void {
    this.callStore.registerModalOpen();
  }

  ngOnDestroy(): void {
    this.callStore.registerModalClosed();
  }
}
